import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ColumnsIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon viewboxSize="sm" {...props}>
    <path
      clipRule="evenodd"
      d="M13.8776 0.00671387C14.508 0.0706278 15 0.602718 15 1.25V13.75L14.9933 13.8776C14.9336 14.466 14.466 14.9336 13.8776 14.9933L13.75 15H1.25L1.12244 14.9933C0.533966 14.9336 0.0663747 14.466 0.00671387 13.8776L0 13.75V1.25C0 0.602718 0.492014 0.070628 1.12244 0.00671387L1.25 0H13.75L13.8776 0.00671387ZM1.25 13.75H5.625V1.25H1.25V13.75ZM9.375 13.75H13.75V1.25H9.375V13.75ZM6.875 13.75H8.125V1.25H6.875V13.75Z"
      fillRule="evenodd"
    />
  </BaseIcon>
);
